<!--
문의상태 원클릭 변경 컴포넌트
- 모달 없이 인라인 버튼으로 상태를 즉시 변경
- 상품문의(qna), 창고문의(work-request) 공용
-->
<template>
    <span class="state-buttons">
        <button
            v-for="option in stateOptions"
            :key="option.val"
            type="button"
            class="uk-button uk-button-xsmall"
            :class="option.val === activeState ? option.activeClass : 'uk-button-default'"
            :disabled="submitting"
            @click="changeState(option.val)"
        >
            {{ option.text }}
        </button>
    </span>
</template>

<script>
    export default {
        props: {
            csrfToken: {
                type: String,
                required: true,
            },
            recordId: {
                type: Number,
                required: true,
            },
            /**
             * API base URL (예: '/qnas' 또는 '/region-work-requests')
             * PATCH {patchUrl}/{recordId}/state 로 호출됨
             */
            patchUrl: {
                type: String,
                required: true,
            },
            currentState: {
                type: Number,
                required: true,
            },
        },
        data: function () {
            return {
                activeState: this.currentState,
                submitting: false,
                stateOptions: [
                    {text: '진행중', val: 1, activeClass: 'uk-button-primary'},
                    {text: '답변완료', val: 2, activeClass: 'uk-button-gray'},
                    {text: '보류중', val: 5, activeClass: 'uk-button-danger'},
                ],
            };
        },
        methods: {
            changeState(val) {
                if (val === this.activeState || this.submitting) {
                    return;
                }

                this.submitting = true;

                $.app.ajax.module.default({
                    type: 'patch',
                    url: this.patchUrl + '/' + this.recordId + '/state',
                    data: {
                        '_token': this.csrfToken,
                        'state': val,
                    },
                    success: (response) => {
                        UIkit.modal.alert('저장되었습니다.').then(() => {
                            $.app.refresh();
                        });
                    },
                    error: () => {
                        this.submitting = false;
                    },
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .state-buttons {
        .uk-button + .uk-button {
            margin-left: 4px;
        }
    }
</style>
